import { MainContentSection } from "components/shared/containers/MainContentContainer";
import BaseRowView from "components/shared/views/BaseRowView";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

import { BCMSRecord, ModalOpen, useBCMSContext, useParams, useRoute } from "@bcm-dev/bcms-vite";
import { Card, LinkedAccount } from "model";
import "./styles.css";

/**
 * @function ManagePaymentsView
 * @returns {React.Component}
 * @description This is the first landing page of the ManagePaymentAccountsPage. 
 * @exported true
 */
export default function ManagePaymentsView(props) {
  const globalController = useBCMSContext();
  const defaultCard =   globalController.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
  const cardID = useParams().cardID ?? defaultCard;
  const card = Card.initByID(cardID);
  BCMSRecord.globalControllerFor([ Card ,LinkedAccount ], globalController);
  const accounts = LinkedAccount.initAll();
  const paymentAccounts = accounts.reduce((paymentAccounts,account) =>  {
   if(account.type !== "credit"){
    paymentAccounts.push(<PaymentAccountRow account={account} key={account.id} card={card}/>  )
   }
   return paymentAccounts;
  },[]) 
  const navigate = useRoute();
  return (
    <div className="manage-payments-view">
      <MainContentSection text="Add New Account"  >
      <ModalOpen id="RedirectModal">
        <BaseRowView mainText="Add Automatically" subText="Link your institution to verify the account"  />
      </ModalOpen>
        <BaseRowView mainText="Add Manually" subText="Enter your account details to verify the account"   onClick={() => {navigate("/home/addaccount/"+cardID)}}/>
      </MainContentSection>
      <MainContentSection text="Manage Existing Payment Accounts">
       {paymentAccounts}
      </MainContentSection>
    </div>
  )
}

/**
 * @function PaymentAccountRow
 * @param {STRING} iconType - Sets the left icon in the BaseRowView to either a savings or a checking account icon. Available icons: DollarMoneyBagIcon and CheckingAccountIcon
 * @param {STRING} paymentAccount - Sets the payment account to the mainText property in the BaseRowView. 
 * @param {STRING} accountType - Sets the account type in the subText. 
 * @param {STRING} lastFour - Sets the account last four numbers in the subText. 
 * @returns {React.Component}
 * @description This is a variation of the BaseRowView used only in the ManagePaymentView. 
 * @exported false
 */
function PaymentAccountRow(props) {
  const iconType = props.account.type.toLowerCase() !== "savings" ?"CheckingAccountIcon":"DollarMoneyBagIcon";
  const paymentAccount = props.account.fi_name ?? "[payment account]";
  const accountType = props.account.type ?? "[accountType]";
  const lastFour = props.account.last_four_digit_number ?? "[lastFour]";
  const navigate = useRoute();
  const path = `/home/managepaymentaccounts/paymentaccountdetails/${props.card.id}/${props.account.id}`
  return (
    <BaseRowView className="payment-account-view" leftIcon={<SVGAsset className="set-width left-icon" id={iconType} />} mainText={paymentAccount} subText={`${accountType} ${lastFour}`} subTextClassName="capitalize" onClick={()=>navigate(path)} />
  )
}